import type { GetTouringTreatmentForZuidAndListingWebApiResponseDto } from '@zg-rentals/ts-z-calendar-client';

type TourCalendarTreatment = Pick<
  GetTouringTreatmentForZuidAndListingWebApiResponseDto,
  'hasAvailability' | 'hasBookedTours' | 'isTouringEnabledForListing'
>;

// Keep in sync with the redirect in apps/zillow-rental-manager-web/src/pages/properties/[listingAlias]/tours/tour-calendar.tsx.
export default function canViewTourCalendar(treatment: TourCalendarTreatment | undefined): boolean {
  if (!treatment) {
    return false;
  }
  return treatment.hasBookedTours || (treatment.hasAvailability && treatment.isTouringEnabledForListing);
}
